module.exports = __webpack_public_path__ + "static/erp-img-2-59dfb4142605eeeb858d4b49dab9c74f.png";